import {
  bidsResponseSchema,
  type BidsResponse,
  type BidStatus,
  type Bid,
} from '../types';
import { ApiClientError } from '@/errors';
import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';

export interface BidFilters {
  readonly status?: BidStatus;
  readonly eventId?: string;
  readonly supplierId?: string;
}

const USE_MOCK = true;

const MOCK_BIDS: Bid[] = [
  {
    bidId: 'bid-001',
    eventId: 'se-001',
    eventNumber: 'SE-2026-0001',
    eventTitle: 'Fresh Produce - Weekly Supply',
    supplierId: 'sup-sysco',
    supplierName: 'Sysco Miami',
    status: 'submitted',
    lines: [
      {
        lineId: 'sel-001',
        itemId: 'item-010',
        itemName: 'Roma Tomatoes',
        sku: 'PROD-TOM-001',
        quantity: 200,
        unit: 'lb',
        unitPrice: 2.80,
        totalPrice: 560,
      },
      {
        lineId: 'sel-002',
        itemId: 'item-011',
        itemName: 'Yellow Onions',
        sku: 'PROD-ONI-001',
        quantity: 150,
        unit: 'lb',
        unitPrice: 1.50,
        totalPrice: 225,
      },
    ],
    subtotal: 785,
    tax: 0,
    total: 785,
    currency: 'USD',
    rank: 1,
    isLowestBid: true,
    deliveryTerms: 'FOB Destination, 48hr delivery',
    validUntil: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(),
    notes: 'Can deliver within 48 hours of order confirmation',
    submittedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    bidId: 'bid-002',
    eventId: 'se-002',
    eventNumber: 'SE-2026-0002',
    eventTitle: 'Premium Seafood - Weekly Order',
    supplierId: 'sup-sysco',
    supplierName: 'Sysco Miami',
    status: 'under_review',
    lines: [
      {
        lineId: 'sel-005',
        itemId: 'item-001',
        itemName: 'Atlantic Salmon Fillet',
        sku: 'SEA-SAL-001',
        quantity: 500,
        unit: 'lb',
        unitPrice: 17.50,
        totalPrice: 8750,
      },
      {
        lineId: 'sel-006',
        itemId: 'item-002',
        itemName: 'Jumbo Shrimp 16/20',
        sku: 'SEA-SHR-001',
        quantity: 300,
        unit: 'lb',
        unitPrice: 21.00,
        totalPrice: 6300,
      },
    ],
    subtotal: 15050,
    tax: 0,
    total: 15050,
    currency: 'USD',
    rank: 2,
    isLowestBid: false,
    deliveryTerms: 'FOB Destination, temperature controlled',
    validUntil: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000).toISOString(),
    submittedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    bidId: 'bid-003',
    eventId: 'se-003',
    eventNumber: 'SE-2026-0003',
    eventTitle: 'Dry Goods - Monthly Supply',
    supplierId: 'sup-usfoods',
    supplierName: 'US Foods',
    status: 'accepted',
    lines: [
      {
        lineId: 'sel-007',
        itemId: 'item-020',
        itemName: 'All-Purpose Flour',
        sku: 'DRY-FLR-001',
        quantity: 50,
        unit: 'bag',
        unitPrice: 18.50,
        totalPrice: 925,
      },
    ],
    subtotal: 925,
    tax: 0,
    total: 925,
    currency: 'USD',
    rank: 1,
    isLowestBid: true,
    deliveryTerms: 'FOB Destination',
    validUntil: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    notes: 'Converted to PO-2026-0001',
    submittedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    reviewedBy: 'user-001',
    reviewedByName: 'John Smith',
    reviewedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    bidId: 'bid-004',
    eventId: 'se-004',
    eventNumber: 'SE-2026-0004',
    eventTitle: 'Dairy Products - Bi-Weekly',
    supplierId: 'sup-dairy',
    supplierName: 'Fresh Dairy Co',
    status: 'rejected',
    lines: [
      {
        lineId: 'sel-008',
        itemId: 'item-030',
        itemName: 'Heavy Cream',
        sku: 'DAI-CRM-001',
        quantity: 100,
        unit: 'qt',
        unitPrice: 4.50,
        totalPrice: 450,
      },
    ],
    subtotal: 450,
    tax: 0,
    total: 450,
    currency: 'USD',
    rank: 3,
    isLowestBid: false,
    deliveryTerms: 'FOB Origin',
    validUntil: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    submittedAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    reviewedBy: 'user-001',
    reviewedByName: 'John Smith',
    reviewedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export async function getBids(filters?: BidFilters): Promise<BidsResponse> {
  if (USE_MOCK) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    
    const filteredBids = MOCK_BIDS.filter((b) => {
      if (filters?.status && b.status !== filters.status) return false;
      if (filters?.eventId && b.eventId !== filters.eventId) return false;
      if (filters?.supplierId && b.supplierId !== filters.supplierId) return false;
      return true;
    });
    
    return {
      data: filteredBids,
      pagination: {
        nextToken: null,
        totalCount: filteredBids.length,
      },
    };
  }

  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.eventId) params.set('eventId', filters.eventId);
  if (filters?.supplierId) params.set('supplierId', filters.supplierId);

  const url = buildApiUrl('/v1/bids', params);
  const response = await authFetch(url);

  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch bids');
  }

  return bidsResponseSchema.parse(await response.json());
}
